import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from '@angular/forms';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonItem,
  IonInput,
  IonButton,
  IonText,
  IonInputPasswordToggle,
  IonLabel,
  IonProgressBar,
  IonToast,
} from '@ionic/angular/standalone';
import { Login } from '../../models/login';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserVerificationService } from 'src/app/services/user-verification.service';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  standalone: true,
  imports: [
    IonToast,
    IonProgressBar,
    IonLabel,
    IonText,
    IonButton,
    IonInput,
    IonItem,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    CommonModule,
    ReactiveFormsModule,
    IonInputPasswordToggle,
    RouterModule,
  ],
})
export class LoginPage {
  loginForm: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, Validators.required),
  });
  loading = false;
  pushNotifToken = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private toastService: ToastService,
    private userVerificationService: UserVerificationService,
  ) {}

  ionViewWillEnter() {
    if (this.tokenService.authToken != "") {
      this.authService.pingBackend().subscribe({
        next: (isLoggedIn) => {
          if (isLoggedIn) {
            this.router.navigateByUrl('/home');
          } else {
            this.tokenService.logout();
          }
        },
        error: (err: any) => {
          this.tokenService.logout();
        },
      });
    }

    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        // Save token to user, update login method to accept token and save on login success
        this.pushNotifToken = token.value;
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
      }
    );
  }
  
  onLoginClick(): void {
    this.loading = true;

    const loginValues: Login = this.loginForm.value as Login;

    this.authService.login(loginValues.email, loginValues.password, this.pushNotifToken).subscribe({
      next: (response) => {
        this.tokenService.updateTokens(response);
        this.loading = false;

        if (response.accountStatus == 'ACTIVE') {
          this.router.navigateByUrl('/home');
        } else if (response.accountStatus == 'REGISTERED') {
          this.userVerificationService.userEmail = loginValues.email;
          this.router.navigateByUrl('/verification');
        }
      },
      error: (response) => {
        this.toastService.presentToast(response.error.suggestedMessage, 3000);
        this.loading = false;
      },
    });
  }
}
